import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _find from 'lodash/find';

import LoadingIndicator from '../LoadingIndicator';
import FormItemContainer from '../Global/Containers/FormItemContainer';
import Toggle from '../Global/Buttons/Toggle';
import RadioField from '../Global/Inputs/RadioField';
import CheckboxInput from '../Global/Inputs/Checkbox';

import combineStyles from '../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';

const styles = theme => ({
  emailDigestion: {
    borderRadius: 4,
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing.unit * 3
  },
  emailDigestionHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginBottom: theme.spacing.unit * 2
  },
  toggleSwitch: {
    position: 'absolute',
    right: -14,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  emailDigestionMessage: {
    marginBottom: [theme.spacing.unit * 3, '!important']
  },
  notificationOptionContainer: {
    marginTop: theme.spacing.unit * 0.5
  },
  notificationOption: {
    display: 'flex',
    height: 56,
    alignItems: 'center',
    borderBottom: '1px solid rgba(12,31,44,0.12)',
    '&:last-child': {
      borderBottom: 0
    }
  },
  notificationOptionLabel: {
    display: 'flex',
    flex: 1,
    margin: [0, '!important']
  },
  emailOption: {
    position: 'relative',
    width: 36,
    marginRight: [theme.spacing.unit * 4.625, '!important'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emailDigestOption: {
    position: 'relative',
    width: 80,
    marginRight: [theme.spacing.unit * 0.875, '!important'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  notificationOptionsCheckboxes: {
    marginTop: [0, '!important'],
    paddingLeft: [theme.spacing.unit * 2.25, '!important']
  }
});

export const MyAccountEmailNotification = ({
  t,
  classes,
  isLoading,
  isSubmitting,
  notificationReasons,
  myUser,
  isEmailEnabled,
  handleEmailToggle,
  handleEmailDigestToggle,
  handleEmailDigestAllToggle,
  handleNotificationPreferenceEmail,
  handleNotificationPreferenceDigest
}) => {
  return (
    <FormItemContainer
      title={t('Email Notifications')}
      secondaryAction={
        <Toggle
          value={isEmailEnabled}
          onChange={() => {
            handleEmailToggle(!isEmailEnabled);
          }}
          inactiveLabel={''}
          activeLabel={''}
        />
      }
    >
      {isLoading || isSubmitting ? (
        <LoadingIndicator />
      ) : (
        <div>
          <div className={classes.emailDigestion}>
            <div className={classes.emailDigestionHeader}>
              <p className={classes.headline7}>Email Digest</p>
              <Toggle
                value={myUser.preferences.receiveEmailDigest}
                onChange={() => {
                  handleEmailDigestToggle(
                    !myUser.preferences.receiveEmailDigest
                  );
                }}
                inactiveLabel={''}
                activeLabel={''}
                classes={{
                  root: classes.toggleSwitch
                }}
              />
            </div>
            <p
              className={classnames(
                classes.body2,
                classes.emailDigestionMessage
              )}
            >
              An email digest will be sent each morning with notifications from
              the previous day.
            </p>
            <RadioField
              options={[
                {
                  value: 'false',
                  label: 'Include only unread notifications'
                },
                { value: 'true', label: 'Include all notifications' }
              ]}
              onChange={() => {
                handleEmailDigestAllToggle(
                  !myUser.preferences.emailDigestReceiveAll
                );
              }}
              value={myUser.preferences.emailDigestReceiveAll.toString()}
              name={'digest'}
            />
          </div>
          <div className={classes.notificationOptionContainer}>
            <div className={classes.notificationOption}>
              <div className={classes.notificationOptionLabel} />
              <p className={classnames(classes.body2, classes.emailOption)}>
                Email
              </p>
              <p
                className={classnames(classes.body2, classes.emailDigestOption)}
              >
                Email Digest
              </p>
            </div>
            {notificationReasons.map((notificationReason, index) => (
              <div className={classes.notificationOption} key={index}>
                <p
                  className={classnames(
                    classes.subtitle3,
                    classes.notificationOptionLabel
                  )}
                >
                  {notificationReason.title}
                </p>
                <p className={classnames(classes.body2, classes.emailOption)}>
                  <CheckboxInput
                    label={null}
                    onChange={() => {
                      handleNotificationPreferenceEmail(notificationReason);
                    }}
                    name={notificationReason.title}
                    value={
                      _find(
                        myUser.preferences.notificationPreferences,
                        function(np) {
                          return (
                            np.notificationReasonId === notificationReason.value
                          );
                        }
                      ) &&
                      _find(
                        myUser.preferences.notificationPreferences,
                        function(np) {
                          return (
                            np.notificationReasonId === notificationReason.value
                          );
                        }
                      ).receiveEmailNotifications
                    }
                    classes={{ root: classes.notificationOptionsCheckboxes }}
                  />
                </p>
                <p
                  className={classnames(
                    classes.body2,
                    classes.emailDigestOption
                  )}
                >
                  <CheckboxInput
                    label={null}
                    onChange={() => {
                      handleNotificationPreferenceDigest(notificationReason);
                    }}
                    name={notificationReason.title}
                    value={
                      _find(
                        myUser.preferences.notificationPreferences,
                        function(np) {
                          return (
                            np.notificationReasonId === notificationReason.value
                          );
                        }
                      ) &&
                      _find(
                        myUser.preferences.notificationPreferences,
                        function(np) {
                          return (
                            np.notificationReasonId === notificationReason.value
                          );
                        }
                      ).includeInEmailDigest
                    }
                    classes={{ root: classes.notificationOptionsCheckboxes }}
                  />
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </FormItemContainer>
  );
};

export default withStyles(
  combineStyles(styles, ButtonStyles, TypographyStyles)
)(withNamespaces()(MyAccountEmailNotification));
